import { useState } from "react"
import axios from "axios"
import { Button } from "react-bootstrap"
import { useQueryClient } from "react-query"
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
} from "components/ui/dialog"

const DeleteRecord = ({
  id,
  endpoint,
  deleted,
}: {
  id: number
  endpoint: string
  deleted?: (id: number) => void
}) => {
  const queryClient = useQueryClient()

  const [show, setShow] = useState(false)
  const del = async () => {
    await axios.delete(`${endpoint}/${id}/`)
    queryClient.invalidateQueries(endpoint)
    setShow(false)
    deleted && deleted(id)
  }

  return (
    <>
      <a href="#" className="action-icon" onClick={() => setShow(true)}>
        <i className="ri-delete-bin-line" />
      </a>
      <Dialog open={show}>
        <DialogHeader
          onClick={() => setShow(false)}
          className="bootstrap-scope"
        >
          <h4 className="modal-title">Confirm Delete</h4>
        </DialogHeader>
        <DialogContent className="p-0">
          <div className="p-4">
            <p className="text-base text-red-500">
              Are you sure you want to delete this record?
            </p>
          </div>
        </DialogContent>
        <DialogFooter className="bootstrap-scope">
          <Button variant="light" onClick={() => setShow(false)}>
            Close
          </Button>{" "}
          <Button variant="primary" onClick={del}>
            Delete
          </Button>
        </DialogFooter>
      </Dialog>
    </>
  )
}

export default DeleteRecord
